import { render, staticRenderFns } from "./MyPrivilege.vue?vue&type=template&id=ed3fdfb8&"
import script from "./MyPrivilege.vue?vue&type=script&lang=js&"
export * from "./MyPrivilege.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports